import { render, staticRenderFns } from "./ImportNewServiceModal.vue?vue&type=template&id=40be8d2a&scoped=true&"
import script from "./ImportNewServiceModal.vue?vue&type=script&lang=js&"
export * from "./ImportNewServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportNewServiceModal.vue?vue&type=style&index=0&id=40be8d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40be8d2a",
  null
  
)

export default component.exports